import React from "react";
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import ContactPageIcon from '@mui/icons-material/ContactPage';
import DesktopMacIcon from '@mui/icons-material/DesktopMac';
import { Button } from "@mui/material";

export default function About() {
  return (
    <section id="about">
      <div className="container mx-auto flex px-10 py-20 md:flex-row flex-col items-center">
        <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
          <h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-white">
            Hi, I'm Shane.
            <br className="hidden lg:inline-block" />Self-driven, Curious & Passionate. Programmer.
          </h1>
          <p className="mb-8 leading-relaxed">
          Software Engineer having industry experience developing RPA bots in the financial sector.
          </p>
          <div className="flex justify-center ">
            
            <Button 
              variant="contained" 
              startIcon={<DesktopMacIcon /> } 
              sx={{marginRight:2,bgcolor:'#1F2937'}}
              href="#projects"
            >
              Portfolio
            </Button>
            <Button 
              variant="contained" 
              startIcon={<ContactPageIcon /> } 
              sx={{marginLeft:2,bgcolor:'#1F2937'}}
              href="./cv.pdf"
            >
              Resume
            </Button>
            <Button 
              variant="contained" 
              startIcon={<LinkedInIcon /> } 
              sx={{marginLeft:2}}
              href="https://www.linkedin.com/in/shane-gracias/"
            >
              LinkedIn
            </Button>
            <Button 
              variant="contained" 
              startIcon={<GitHubIcon /> } 
              sx={{marginLeft:2,bgcolor:'black'}}
              href="https://github.com/shanegracias7"
            >
              GitHub
            </Button>
            

          </div>
        </div>
        <div className="lg:max-w-lg lg:w-full md:w-1/2 w-5/6" style={{}}>
          <img
            className="object-cover object-center rounded"
            alt="shane"
            src="./shane.jpg"
            style={{borderRadius:'50%'}}
          />
        </div>
      </div>
    </section>
  );
}